<template>
    <v-container fluid>
        <v-btn
            :loading="subscriptionsWithInfo === null"
            @click="newSubscription"
            bottom
            class="mb-10"
            color="secondary darken-1"
            fab
            fixed
            right
        >
            <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-row align="center" no-gutters>
            <v-col cols="12" justify="center" lg="4" sm="6">
                <v-subheader>
                    <h2>Subscriptions ({{ totalMatches }})</h2>
                </v-subheader>
            </v-col>
            <v-col cols="12" lg="4" sm="6">
                <v-text-field
                    @click:clear="setSearch('')"
                    @input="setSearch"
                    clearable
                    label="Search"
                    prepend-icon="mdi-magnify"
                    single-line
                />
            </v-col>
            <v-col class="text-right" cols="12" lg="4" sm="6">
                <!--<v-btn
                    @click="showFilters = !showFilters"
                    color="secondary darken-1"
                    icon
                >
                    <v-icon>mdi-tune</v-icon>
                </v-btn>-->
            </v-col>
        </v-row>
        <v-container class="pb-10">
            <v-row justify="center" v-if="subscriptionsWithInfo === null">
                <v-col :key="i" cols="12" lg="6" v-for="i in 6">
                    <v-skeleton-loader
                        elevation="4"
                        type="card"
                    ></v-skeleton-loader>
                </v-col>
            </v-row>
            <v-row justify="center" v-else>
                <v-col
                    :key="subscriptionWithInfo.entity.id"
                    cols="12"
                    lg="6"
                    v-for="subscriptionWithInfo in subscriptionsWithInfo"
                >
                    <!--@click="loadSubscriptionForm(subscriptionWithInfo.entity)"-->
                    <v-card
                        @click="
                            loadSubscriptionForm(subscriptionWithInfo.entity)
                        "
                        class="entity-card fill-height"
                        elevation="4"
                        style="overflow: hidden"
                    >
                        <v-card-title>
                            <h5>{{ subscriptionWithInfo.entity.name }}</h5>
                        </v-card-title>
                        <div>
                            <v-card-text class="center-content pa-2">
                                <v-row justify="space-around">
                                    <v-col
                                        class="text-center"
                                        cols="6"
                                        lg="3"
                                        md="4"
                                        xl="2"
                                    >
                                        <v-card class="pa-1 ma-1 fill-height">
                                            Amount
                                            <br />
                                            <h3>
                                                R{{subscriptionWithInfo.entity.amount.toFixed(2)}}
                                            </h3>
                                        </v-card>
                                    </v-col>

                                    <v-col
                                        class="text-center"
                                        cols="6"
                                        lg="3"
                                        md="4"
                                        xl="2"
                                    >
                                        <v-card class="pa-1 ma-1 fill-height">
                                            Dependants
                                            <br />
                                            <h3>
                                                {{subscriptionWithInfo.entity.dependantsCount}}
                                            </h3>
                                        </v-card>
                                    </v-col>

                                </v-row>
                            </v-card-text>
                        </div>
                        <!--<v-card-text class="pt-0">Customers: {{providerGroupWithInfo.info.customerCount}}</v-card-text>-->
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <v-dialog persistent v-model="subscriptionFormVisible" width="500px">
            <SubscriptionForm
                :key="subscriptionFormKey"
                :subscription-in="subscriptionFormSubscription"
                @close="closeSubscriptionForm"
                @deleted="deleteSubscription"
                @saved="updateSubscription"
            />
        </v-dialog>

        <v-pagination
            :length="pagesCount"
            @input="paginationDebounce(500, true)"
            class="pagination-bar base-background"
            total-visible="7"
            v-model="pageNo"
            v-show="pagesCount > 1"
        ></v-pagination>
    </v-container>
</template>

<script>
//import Subscription from "../models/Subscription.model";
import uuid4 from "../helpers/uuid4";
import Subscription from "../models/Subscription.model";
import SubscriptionForm from "../components/forms/SubscriptionForm";

export default {
    name: "Subscriptions",
    props: [],
    data: function () {
        return {
            //main data
            subscriptionsWithInfo: null,
            //pagination
            pageNo: 1,
            pageSize: 6,
            pagesCount: 0,
            totalMatches: null,
            searchString: "",
            orderBy: "",
            sortOrder: null,
            paginationTimeout: null,
            requestId: uuid4(),

            //form
            subscriptionFormVisible: false,
            subscriptionFormKey: 0,
            subscriptionFormSubscription: new Subscription(),
        };
    },
    mounted: function () {
        this.getSubscriptions();
    },
    //activated: function(){//when keep a live is brought back up},
    components: {
        SubscriptionForm,
        //
    },
    methods: {
        getSubscriptions() {
            var requestId = (this.requestId = uuid4());
            this.$store
                .dispatch("subscriptions/get", {
                    id: null,
                    urlParameters: {
                        pageNo: this.pageNo,
                        pageSize: this.pageSize,
                        searchString: this.searchString,
                        orderBy: this.orderBy,
                        sortOrder: this.sortOrder,
                    },
                    requestId: requestId,
                })
                .then((subscriptionsResponse) => {
                    if (this.requestId == subscriptionsResponse.requestId) {
                        this.subscriptionsWithInfo =
                            subscriptionsResponse.data.page;
                        this.totalMatches = subscriptionsResponse.data.total;
                        this.pageSize = subscriptionsResponse.data.pageSize;
                        this.pageNo = subscriptionsResponse.data.pageNumber;
                        this.pagesCount = Math.ceil(
                            subscriptionsResponse.data.total / this.pageSize
                        );
                    }
                });
        },
        paginationDebounce(debounceTime, isPaging) {
            if (!isPaging) {
                this.pageNo = 1;
                this.pagesCount = 0;
            }
            if (this.subscriptionsWithInfo !== null)
                this.subscriptionsWithInfo = null;
            clearTimeout(this.paginationTimeout);
            this.paginationTimeout = setTimeout(
                this.getSubscriptions,
                debounceTime
            );
        },
        setSearch(value) {
            this.searchString = value;
            this.paginationDebounce(1000);
        },

        //FORM METHODS---------------------------------
        newSubscription() {
            var subscription = new Subscription();
            subscription.id = 0;
            this.loadSubscriptionForm(subscription);
        },
        loadSubscriptionForm(subscription) {
            this.subscriptionFormSubscription = new Subscription().set(
                subscription
            );
            this.subscriptionFormKey = subscription.id;
            this.subscriptionFormVisible = true;
        },
        closeSubscriptionForm() {
            this.subscriptionFormVisible = false;
            this.subscriptionFormSubscription = new Subscription();
            this.subscriptionFormKey = null;
        },
        updateSubscription() {
            this.paginationDebounce(0);
        },
        deleteSubscription() {
            this.paginationDebounce(0);
        },
    },
};
</script>

<style lang="stylus" scoped>
.entity-card {
    /* background: linear-gradient(45deg, rgba(127,127,127,0.1), transparent,rgba(127,127,127,0.1)) */
    .center-content {
        background-color: rgba(127, 127, 127, 0.15);
    }
}

.pagination-bar {
    // position: fixed;
    bottom: 0;
    margin: auto;
    left: 0;
    right: 0;
    padding-bottom: 0.1rem;
    padding-top: 0.1rem;
    /*
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border:1px solid rgba(127, 127, 127, 0.2)
    */
}

.theme--light {
    .base-background {
        background: #FFFFFF;
    }
}

.theme--dark {
    .base-background {
        background: #121212;
    }
}
</style>
